import { createSlice } from "@reduxjs/toolkit";

import { getInitialLanguageFromCookie } from "../helper/getInitialLanguageFromCookie";
// const loadSignupData = () => {
//     const data = localStorage.getItem("signupData");
//     return data ? JSON.parse(data) : { fullName: "", mobileNumber: "", countryCode: "+91", email: "" };
// };
const storedUser = JSON.parse(localStorage.getItem("user"));
const storedAuth = JSON.parse(localStorage.getItem("isAuthenticated"));
const savedLang = localStorage.getItem('selectedLang') || 'en';


const initialState = {


    // signupData: loadSignupData()
    selectedLang: getInitialLanguageFromCookie(),

    user: storedUser || null,
    isAuthenticated: storedAuth || false,
    selectedCategory: null,
    selectedSubCategory: null,
    selectedEmailTemplate: null,
    selectedPackage: null,
    selectedShippingCharge: null,
    selectedShipDuration: null,
    selectedCalPackage: null,
    selectedFollowUp: null,
    selectedCoupon: null,
    selectedUser: null,




};


const authModalSlice = createSlice({
    name: "authModal",
    initialState,
    reducers: {





        login: (state, action) => {


            state.user = action.payload;
            state.isAuthenticated = true;
            localStorage.setItem("user", JSON.stringify(action.payload));
            localStorage.setItem("isAuthenticated", JSON.stringify(true));
        },

        logout: (state) => {
            state.user = null;
            state.isAuthenticated = false;
            localStorage.removeItem("user");
            localStorage.removeItem("isAuthenticated");
        },

        setSelectedCategory: (state, action) => {
            state.selectedCategory = action.payload;
        },
        clearSelectedCategory: (state) => {
            state.selectedCategory = null;
        },
        setSelectedSubCategory: (state, action) => {
            state.selectedSubCategory = action.payload;
        },
        clearSelectedSubCategory: (state) => {
            state.selectedSubCategory = null;
        },

        setSelectedEmailTemplate: (state, action) => {
            state.selectedEmailTemplate = action.payload;
        },

        clearSelectedEmailTemplate: (state, action) => {
            state.selectedEmailTemplate = action.payload;

        },

        setSelectedPackage: (state, action) => {

            state.selectedPackage = action.payload;

        },

        clearSelectedPackage: (state, action) => {
            state.selectedPackage = action.payload;
        },

        setSelectedShippingCharge: (state, action) => {

            state.selectedShippingCharge = action.payload;

        },

        clearSelectedShippingCharge: (state, action) => {

            state.selectedShippingCharge = action.payload;

        },


        setSelectedShipDuration: (state, action) => {
            state.selectedShipDuration = action.payload;

        },


        clearSelectedShipDuration: (state, action) => {
            state.selectedShipDuration = action.payload;

        },

        setSelectedCalPackage: (state, action) => {

            state.selectedCalPackage = action?.payload

        },

        clearSelectedCalPackage: (state, action) => {

            state.selectedCalPackage = action?.payload

        },

        setSelectedFollowUp: (state, action) => {
            state.selectedFollowUp = action?.payload;

        },

        clearSelectedFollowUp: (state, action) => {

            state.selectedFollowUp = action.payload

        },

        setSelectedCoupon: (state, action) => {


            state.selectedCoupon = action.payload

        },

        clearSelectedCoupon: (state, action) => {


            state.selectedCoupon = action.payload

        },


        setSelectedUser: (state, action) => {
            state.selectedUser = action.payload

        },


        clearSelectedUser: (state, action) => {
            state.selectedUser = action.payload

        },
        setLanguage: (state, action) => {
            console.log('[Redux] Setting language to:', action.payload);
            state.selectedLang = action.payload;
            try {
                localStorage.setItem('selectedLang', action.payload);
            } catch (e) {
                console.error('[Redux] Failed to save to localStorage:', e);
            }
        },






    },
});

export const {

    logout,

    login,
    setSelectedCategory,
    setSelectedEmailTemplate,
    clearSelectedEmailTemplate,
    clearSelectedCategory,
    setSelectedSubCategory,
    clearSelectedSubCategory,
    setSelectedPackage,
    clearSelectedPackage,
    setSelectedShippingCharge,
    clearSelectedShippingCharge,
    setSelectedShipDuration,
    clearSelectedShipDuration,
    setSelectedCalPackage,
    clearSelectedCalPackage,
    setSelectedFollowUp,
    clearSelectedFollowUp,
    setSelectedCoupon,
    clearSelectedCoupon,
    setSelectedUser,
    clearSelectedUser,
    setLanguage } = authModalSlice.actions;
export default authModalSlice.reducer;
